import { Character } from './Character'
import { withCharacter } from './withCharacter'

const ConnectedCharacter = withCharacter(Character)

export { ConnectedCharacter as Character }
